import { DatePipe } from '@angular/common';
import { Component, HostListener, Input, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { AccordionModule } from 'primeng/accordion';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ButtonComponent } from '../../../../../../@core/components/ui/button/button.component';
import { DeleteConfirmationComponent } from '../../../../../../@core/components/ui/delete-confirmation/delete-confirmation.component';
import { CONTRACT_USER_ROLE } from '../../../../../../@core/models/model';
import { ToastService } from '../../../../../../@core/services/toast.service';
import { SearchBarComponent } from '../../../../../../@shared/components/search-bar/search-bar.component';
import { TruncatePipe } from "../../../../../../@shared/pipes/truncate.pipe";
import { UserNameDisplayComponent } from "../../../../../../@shared/components/user-name-display/user-name-display.component";
import { DOCUMENT_MODEL, IContract } from '../../../../../models/contract-management.model';
import { CompareSelectionComponent } from '../compare-selection/compare-selection.component';
import { CompareService } from '../compare.service';

@Component({
  selector: 'app-compare-history',
  imports: [
    ButtonComponent,
    FormsModule,
    AccordionModule,
    ProgressSpinnerModule,
    UserNameDisplayComponent,
    TruncatePipe,
    DatePipe,
    InputGroupAddonModule,
    InputGroupModule,
    SearchBarComponent,
    CompareSelectionComponent,
    DeleteConfirmationComponent
  ],
  standalone: true,
  templateUrl: './compare-history.component.html',
  styleUrl: './compare-history.component.scss'
})
export class CompareHistoryComponent {

  @Input() documentId!: IContract['_id'];
  @Input() navRequired: boolean = false;
  @Input() documentType: string = '';
  @Input() documentName: string = '';
  @Input() projectId: string = '';
  @Input() role: string = "";
  CONTRACT_USER_ROLE = CONTRACT_USER_ROLE;

  history: any = [];
  filteredHistory: any = [];
  loading: boolean = false;
  showCompareSelection = signal<boolean>(false);
  showDeleteDialog: boolean = false;
  selectedComparisonId: string = '';
  selectedComparisonName: string = '';

  DOCUMENT_MODEL = DOCUMENT_MODEL;
  constructor(
    private compareService: CompareService,
    private router: Router,
    private toast: ToastService
  ) { }

  ngOnInit() {
    this.getHistory();
  }
  getHistory() {
    this.loading = true;
    this.compareService.getHistory(this.documentId).subscribe((res) => {
      this.history = res.data;
      this.filteredHistory = this.history
      this.loading = false;
    });
  }

  @HostListener('document:visibilitychange', ['$event'])
  onVisibilityChange(event: Event): void {
    if (!document.hidden) {
      this.getHistory();
    }
  }

  openCompareDialog() {
    this.showCompareSelection.set(true);
  }

  onCompareSelectionClosed(comparisonId: string | undefined) {
    // visible model will automatically update showCompareSelection via two-way binding
    if (comparisonId) {
      const url = this.router.createUrlTree(['/compare'], {
        queryParams: {
          comparisonId: comparisonId
        },
      }).toString();
      window.open(url, '_blank');
    }
  }

  openComparison(compareId: string) {
    const url = this.router.createUrlTree(['/compare'], { queryParams: { comparisonId: compareId } }).toString();
    window.open(url, '_blank');
  }

  confirmDeleteComparison(compareId: string, compareName: string) {
    this.selectedComparisonId = compareId;
    this.selectedComparisonName = compareName;
    this.showDeleteDialog = true;
  }

  deleteComparison() {
    this.compareService.deleteComparison(this.selectedComparisonId).subscribe((res) => {
      if (res.success) {
        this.toast.success('Comparison deleted successfully');
        this.showDeleteDialog = false;
        this.getHistory();
      }
    });
  }

  openDocument(id: string, docModel: string) {
    let url = '';
    switch (docModel) {
      case 'Contract':
        url = this.router.createUrlTree(['/edit-document'], { queryParams: { documentId: id } }).toString();
        window.open(url, '_blank');
        break;
      case 'File':
        url = this.router.createUrlTree(['/settings/repository'], { queryParams: { fileId: id } }).toString();
        window.open(url, '_blank');
        break;
      case 'Version':
        url = this.router.createUrlTree(['/versions'], { queryParams: { documentId: id } }).toString();
        window.open(url, '_blank');
        break;
    }
  }
  searchCompares(searchValue: string) {
    if (searchValue.toLowerCase() == "") {
      this.filteredHistory = this.history;
    }
    else {
      this.filteredHistory = this.history.filter((compare: any) => {
        return compare.name.toLowerCase().includes(searchValue.toLowerCase());
      });
    }
  }

}
